export const giftCardDurationTypes = {
  days: 'days',
  months: 'months',
  years: 'years',
}
